module.exports = __webpack_public_path__ + "static/media/0081.2525bd4c.jpg";